import { Download, ExternalLink, FileQuestion } from 'lucide-react';
import { useState } from 'react';
import { attachmentKind, fileSize, type Attachment } from '@/lib/attachments';

export function FilePreview({ file }: { file: Attachment }) {
  const [failed, setFailed] = useState(false);
  const kind = attachmentKind(file.mime);
  return (
    <div data-slot="file-preview" className="flex flex-col gap-4">
      <p className="text-xs text-fg-muted">
        {file.mime || 'Файл'} · {fileSize(file.size)}
      </p>
      {file.url && !failed && kind === 'image' ? (
        <div className="overflow-hidden rounded-sm border border-line bg-muted">
          <img
            className="max-h-96 w-full object-contain"
            src={file.url}
            alt={file.name}
            onError={() => setFailed(true)}
          />
        </div>
      ) : file.url && kind === 'pdf' ? (
        <>
          <iframe
            title={'Просмотр PDF: ' + file.name}
            src={file.url}
            className="h-96 w-full rounded-sm border border-line bg-muted"
          />
          <p className="text-xs text-fg-muted">Если встроенный просмотр недоступен, открой PDF отдельно.</p>
        </>
      ) : (
        <div className="rounded-sm border border-line bg-muted p-5 text-sm text-fg-muted">
          <FileQuestion className="mb-3 size-6" />
          {failed ? 'Не удалось показать изображение.' : 'Для этого типа файла доступно скачивание.'}
        </div>
      )}
      {file.url && (
        <div className="flex flex-wrap gap-4">
          <a
            href={file.url}
            download={file.name}
            className="inline-flex items-center gap-1.5 rounded-xs text-xs font-medium text-brand-fg focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
          >
            <Download className="size-4" />
            Скачать
          </a>
          {kind !== 'file' && (
            <a
              href={file.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 rounded-xs text-xs font-medium text-brand-fg focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
            >
              <ExternalLink className="size-4" />
              Открыть отдельно
            </a>
          )}
        </div>
      )}
    </div>
  );
}
